<template>
    <div class="d-flex flex-column justify-content-center">
        <button
            style="min-width: 300px"
            type="button"
            class="btn btn-sm btn-outline-secondary dropdown-toggle d-md-none"
            @click.stop.prevent="toggleDisplay = !toggleDisplay">
            {{ $tl("labels.form.pickColumnsToDisplay") }}
        </button>
        <div style="min-width: 300px" :class="{ 'd-none': toggleDisplay }" class="d-md-block">
            <vue-multiselect
                :disabled="isLoading"
                v-model="selectedColumns"
                :multiple="true"
                :options="options"
                :max-height="300"
                :placeholder="$tl('labels.form.pickColumnsToDisplay')"
                :searchable="false"
                :close-on-select="false"
                :show-labels="false"
                label="label"
                track-by="value"
                @input="updateColumns"
                open-direction="bottom">
            </vue-multiselect>
        </div>
    </div>
</template>
<script>
import VueMultiselect from "vue-multiselect";
import ColumnReservationEnum from "../../../../mixins/enums/booking/ColumnReservationEnum.js";

const datatableColumnsByRestaurantPromise = new Map();

export default {
    inject: {
        nsToolbarContext: {
            default: null,
        },
    },
    components: {
        VueMultiselect,
    },
    mixins: [ColumnReservationEnum],
    props: {
        settings: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {
            selectedColumns: [],
            backupSelectedOptions: [],
            isLoading: false,
            options: [],
            toggleDisplay: true,
        };
    },
    computed: {
        restaurantId() {
            return Number.parseInt(this.$route.params.restaurant_id);
        },
        url() {
            let url = `/api/restaurants/${this.restaurantId}/reservations/datatable-columns`;

            if (this.settings.props && this.settings.props.serviceId) {
                url = url.concat("?", `service=${this.settings.props.serviceId}`);
            }

            return url;
        },
        selectedColumnsSanitized() {
            return this.selectedColumns.map((object) => object.value);
        },
    },
    created() {
        this.getColumns();
    },
    methods: {
        emitToolbarEvent(eventName, data) {
            if (this.nsToolbarContext && typeof this.nsToolbarContext.emitEvent === "function") {
                this.nsToolbarContext.emitEvent(eventName, data);
                return;
            }

            this.$parent.$emit("emit-event", { eventName, data });
        },
        mapToLabel(value) {
            return value.map((element) => {
                return {
                    label: this.getLabelColumnReservation(element, this.restaurantId),
                    value: element,
                };
            });
        },
        getColumnsByServiceMap() {
            const cacheKey = String(this.restaurantId);

            if (!datatableColumnsByRestaurantPromise.has(cacheKey)) {
                const requestPromise = this.httpGet(`/api/restaurants/${this.restaurantId}/reservations/datatable-columns`, {
                    handleReject: false,
                }).then((response) => {
                    if (response === false || !response.data || typeof response.data.columns_by_service !== "object") {
                        return null;
                    }

                    return response.data.columns_by_service;
                });

                datatableColumnsByRestaurantPromise.set(cacheKey, requestPromise);
            }

            return datatableColumnsByRestaurantPromise.get(cacheKey);
        },
        getColumns() {
            const serviceId = String(this.settings.props && this.settings.props.serviceId ? this.settings.props.serviceId : "");

            this.getColumnsByServiceMap().then((columnsByService) => {
                if (columnsByService && Object.prototype.hasOwnProperty.call(columnsByService, serviceId)) {
                    this.selectedColumns = this.mapToLabel(columnsByService[serviceId].columns);
                    this.options = this.mapToLabel(columnsByService[serviceId].options);
                    this.emitToolbarEvent("update-columns", this.selectedColumnsSanitized);
                    return;
                }

                this.httpGet(this.url, { handleReject: false }).then((response) => {
                    if (response === false) {
                        return;
                    }

                    this.selectedColumns = this.mapToLabel(response.data.columns);
                    this.options = this.mapToLabel(response.data.options);
                    this.emitToolbarEvent("update-columns", this.selectedColumnsSanitized);
                });
            });
        },
        updateColumns() {
            this.isLoading = true;
            this.httpPut(this.url, { columns: this.selectedColumnsSanitized })
                .then((response) => {
                    if (response !== false) {
                        const serviceId = String(this.settings.props && this.settings.props.serviceId ? this.settings.props.serviceId : "");
                        const cacheKey = String(this.restaurantId);
                        const cachePromise = datatableColumnsByRestaurantPromise.get(cacheKey);
                        if (cachePromise) {
                            cachePromise.then((columnsByService) => {
                                if (columnsByService && columnsByService[serviceId]) {
                                    columnsByService[serviceId].columns = [...this.selectedColumnsSanitized];
                                }
                            });
                        }

                        this.emitToolbarEvent("update-columns", this.selectedColumnsSanitized);
                    } else {
                        this.selectedColumns = this.backupSelectedOptions;
                    }
                })
                .finally(() => (this.isLoading = false));
        },
    },
    watch: {
        selectedColumns: {
            handler(newValue, oldValue) {
                this.backupSelectedOptions = oldValue;
            },
            deep: true,
        },
    },
};
</script>
